/*
 * OOO Bundle Builder — "Build Your Daily Stack".
 * Ported from the static figma-to-html bundle page. Drives:
 *   - Step 1: quantity tier select (size / base price / tier discount)
 *   - Step 2: gummy add / stepper, live progress slots, over/under guard
 *   - Step 3: subscribe vs buy-once plan, cadence chips, live subtotal,
 *             tier savings, dynamic CTA label.
 *
 * Storefront integration (skill §8): instead of redirecting to /cart, the
 * CTA collects each selected SKU's variant id (from the markup, sourced
 * from section settings) and AJAX-adds them to the OOO side cart, then
 * opens it via window.OOOCart. On an EMPTY store (no variant ids), it
 * gracefully no-ops the fetch and just opens the drawer — never breaks.
 *
 * Scoped per-section so multiple builders on a page (unlikely) won't clash.
 */
(function () {
  'use strict';

  function money(n) { return '$' + Math.round(n); }

  function initBuilder(builder) {
    if (!builder || builder.dataset.oooBuilderInit === '1') return;
    builder.dataset.oooBuilderInit = '1';

    var SUB_DISC = parseFloat(builder.dataset.subDisc || '0.15'); // subscribe saving on top of tier

    var qcards   = Array.prototype.slice.call(builder.querySelectorAll('.ooo-qcard'));
    var gcards   = Array.prototype.slice.call(builder.querySelectorAll('.ooo-gcard'));
    var selCount = builder.querySelector('[data-ooo-sel-count]');
    var selTotal = builder.querySelector('[data-ooo-sel-total]');
    var moreLeft = builder.querySelector('[data-ooo-more-left]');
    var moreWrap = builder.querySelector('.ooo-bprog__more');
    var slotsWrap= builder.querySelector('[data-ooo-slots]');
    var cta      = builder.querySelector('[data-ooo-builder-cta]');
    var subPrice = builder.querySelector('[data-ooo-sub-price]');
    var subStrike= builder.querySelector('[data-ooo-sub-strike]');
    var oncePrice= builder.querySelector('[data-ooo-once-price]');
    var savedAmt = builder.querySelector('[data-ooo-saved]');

    var activeQ = builder.querySelector('.ooo-qcard.is-active') || qcards[0];
    if (!activeQ) return;

    var target   = parseInt(activeQ.dataset.size, 10) || 6;
    var perBase  = parseFloat(activeQ.dataset.base) || 0;
    var tierDisc = parseFloat(activeQ.dataset.disc) || 0;
    var planMode = 'sub';            // 'sub' | 'once'
    var qty = {};                    // sku -> count

    function totalSelected() {
      var t = 0; for (var k in qty) { if (qty.hasOwnProperty(k)) t += qty[k]; } return t;
    }

    function buildSlots() {
      if (!slotsWrap) return;
      slotsWrap.innerHTML = '';
      for (var i = 0; i < target; i++) {
        var s = document.createElement('span');
        s.className = 'ooo-bprog__slot';
        slotsWrap.appendChild(s);
      }
    }

    function render() {
      var sel = totalSelected();
      if (selCount) selCount.textContent = sel;
      if (selTotal) selTotal.textContent = target;
      var left = Math.max(target - sel, 0);
      if (moreLeft) moreLeft.textContent = left;
      if (moreWrap) {
        moreWrap.classList.toggle('is-done', left === 0);
        moreWrap.innerHTML = left === 0 ? 'all set ✓' : ('<b>' + left + '</b> more to go');
      }

      if (slotsWrap) {
        Array.prototype.slice.call(slotsWrap.children).forEach(function (s, i) {
          s.classList.toggle('is-filled', i < sel);
        });
      }

      gcards.forEach(function (c) {
        var n = qty[c.dataset.sku] || 0;
        c.classList.toggle('is-selected', n > 0);
      });

      // pricing: list = target * perBase; tier disc -> buy-once; sub disc on top
      var listTotal = target * perBase;
      var onceTotal = listTotal * (1 - tierDisc);
      var subTotal  = onceTotal * (1 - SUB_DISC);
      if (subStrike) subStrike.textContent = money(listTotal);
      if (subPrice)  subPrice.textContent  = money(subTotal);
      if (oncePrice) oncePrice.textContent = money(onceTotal);
      if (savedAmt)  savedAmt.textContent  = money(listTotal - subTotal);

      // CTA state
      if (cta) {
        var over = sel > target;
        if (left > 0) { cta.disabled = true; cta.textContent = 'Select ' + left + ' more to continue'; }
        else if (over) { cta.disabled = true; cta.textContent = 'Remove ' + (sel - target) + ' to continue'; }
        else {
          cta.disabled = false;
          cta.textContent = (planMode === 'sub' ? 'Subscribe — ' : 'Add to cart — ') +
                            money(planMode === 'sub' ? subTotal : onceTotal);
        }
      }
    }

    // quantity tier select
    qcards.forEach(function (card) {
      card.addEventListener('click', function () {
        qcards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        target   = parseInt(card.dataset.size, 10) || target;
        perBase  = parseFloat(card.dataset.base) || perBase;
        tierDisc = parseFloat(card.dataset.disc) || 0;
        // trim over-selection down to the new (smaller) target
        var over = totalSelected() - target;
        if (over > 0) {
          for (var i = 0; i < gcards.length; i++) {
            var sku = gcards[i].dataset.sku;
            while (over > 0 && qty[sku] > 0) { qty[sku]--; over--; }
            gcards[i].dispatchEvent(new Event('ooo:bsync'));
          }
        }
        buildSlots();
        render();
      });
    });

    // gummy add / stepper
    gcards.forEach(function (card) {
      var sku = card.dataset.sku;
      qty[sku] = 0;
      var addBtn  = card.querySelector('.ooo-gcard__add');
      var stepper = card.querySelector('.ooo-stepper');
      var nEl     = card.querySelector('.ooo-stepper__n');
      var inc     = card.querySelector('[data-ooo-inc]');
      var dec     = card.querySelector('[data-ooo-dec]');

      function sync() {
        var n = qty[sku];
        if (n > 0) { if (addBtn) addBtn.hidden = true; if (stepper) stepper.hidden = false; if (nEl) nEl.textContent = n; }
        else { if (addBtn) addBtn.hidden = false; if (stepper) stepper.hidden = true; }
      }
      card.addEventListener('ooo:bsync', sync);

      if (addBtn) addBtn.addEventListener('click', function () {
        if (totalSelected() >= target) return;
        qty[sku]++; sync(); render();
      });
      if (inc) inc.addEventListener('click', function () {
        if (totalSelected() >= target) return;
        qty[sku]++; sync(); render();
      });
      if (dec) dec.addEventListener('click', function () {
        qty[sku] = Math.max(0, qty[sku] - 1); sync(); render();
      });
      sync();
    });

    // plan select
    builder.querySelectorAll('.ooo-plan__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        builder.querySelectorAll('.ooo-plan__opt').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        planMode = opt.dataset.plan;
        render();
      });
    });

    // cadence chips (don't bubble to the plan card click)
    builder.querySelectorAll('.ooo-cad').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.stopPropagation();
        builder.querySelectorAll('.ooo-cad').forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
      });
    });

    // ── ADD ALL TO CART → OOO side cart (no redirect) ──
    var subPlan = (builder.dataset.subPlan || '').trim();
    function selectedItems() {
      var items = [];
      gcards.forEach(function (c) {
        var n = qty[c.dataset.sku] || 0;
        var vid = (c.dataset.variantId || '').trim();
        if (n > 0 && vid) {
          var item = { id: vid, quantity: n };
          if (planMode === 'sub' && subPlan) item.selling_plan = subPlan;
          items.push(item);
        }
      });
      return items;
    }

    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.disabled) return;
        var items = selectedItems();
        cta.setAttribute('aria-busy', 'true');

        if (!items.length) {
          // EMPTY store (no real variant ids wired) → just open the drawer, never break.
          cta.removeAttribute('aria-busy');
          if (window.OOOCart && window.OOOCart.open) window.OOOCart.open();
          else document.dispatchEvent(new Event('ooo:cart:refresh'));
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().catch(function () { return null; }); })
          .then(function () {
            if (window.OOOCart && window.OOOCart.refresh) {
              return window.OOOCart.refresh().then(function () {
                if (window.OOOCart.open) window.OOOCart.open();
              });
            }
            document.dispatchEvent(new Event('ooo:cart:refresh'));
          })
          .catch(function () {
            document.dispatchEvent(new Event('ooo:cart:refresh'));
          })
          .finally(function () { cta.removeAttribute('aria-busy'); });
      });
    }

    buildSlots();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-ooo-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init when the theme editor re-renders this section.
  document.addEventListener('shopify:section:load', function (e) {
    var b = e.target.querySelector('[data-ooo-builder]');
    if (b) initBuilder(b);
  });
})();
